import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

// Função para buscar anuncio propriedade

export const buscarAnuncioPropriedadeService = async (
  cotasUsuariosId: number
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade/venda/cotaUsuario/${cotasUsuariosId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      return Object.keys(response.data).length > 0 ? true : false;
    } catch (error) {
      console.log(error);
    }
  }
};

export {};
